import type { SendOptions, SendResult } from "./types";

/** Send events to Meta Graph API Conversions endpoint */
export async function sendEvents(opts: SendOptions): Promise<SendResult> {
  const {
    pixelId,
    accessToken,
    events,
    testEventCode,
    graphVersion = "v19.0",
    debug = false,
  } = opts;

  const url = new URL(`https://graph.facebook.com/${graphVersion}/${pixelId}/events`);
  url.searchParams.set("access_token", accessToken);

  const body: any = { data: events };
  if (testEventCode) body.test_event_code = testEventCode;

  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  let json: any = null;
  try { json = await res.json(); } catch { json = null; }

  if (debug) {
    // eslint-disable-next-line no-console
    console.log("[meta-graph-capi] sent", JSON.stringify(body, null, 2));
    // eslint-disable-next-line no-console
    console.log("[meta-graph-capi] response", res.status, json);
  }

  return { ok: res.ok, status: res.status, body: json };
}
